module.exports = __webpack_public_path__ + "dc06d406f6b05b70f6db776664f6ef20.png";